import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Popup,
  Text,
  TooltipDescription,
} from './styles';

const CardItemComponent = (props) => {
  const {
    hasMargin,
    children,
    hasTooltip,
    tooltipContent,
  } = props;

  return (
    <Container hasMargin={hasMargin}>
      {children}

      {(hasTooltip && tooltipContent) && (
        <Popup
          content={<Text>{tooltipContent}</Text>}
          position="top center"
          size="mini"
          trigger={(
            <TooltipDescription>
              <Text tooltip>i</Text>
            </TooltipDescription>
          )}
          wide
        />
      )}
    </Container>
  );
};

CardItemComponent.propTypes = {
  children: PropTypes.node.isRequired,
  hasTooltip: PropTypes.bool,
  tooltipContent: PropTypes.string,
  hasMargin: PropTypes.bool,
};

CardItemComponent.defaultProps = {
  hasMargin: false,
  hasTooltip: false,
  tooltipContent: '',
};

export default CardItemComponent;
